// extracted by mini-css-extract-plugin
export default {"wrap":"JH-z","heading":"KH-z","brandPromo":"LH-z"};